module.exports = __webpack_public_path__ + "static/media/insurance-benefits-non-tca.6876b483.mp3";